module.exports = __webpack_public_path__ + "img/voorbeeldzin.b1289953.png";